import { FormControl, UntypedFormGroup } from '@angular/forms';
import { PersonalDetailsFormField } from '../../models/appliance-details-stepped/personal-details-form-field.enum';
import { PersonalDetailsForm } from '../../models/appliance-details-stepped/personal-details-form.interface';

export const mockPersonalDetailsForm: PersonalDetailsForm = {
  [PersonalDetailsFormField.Address]: new UntypedFormGroup({
    id: new FormControl(),
    addressLine1: new FormControl(),
    addressLine2: new FormControl(),
    addressLine3: new FormControl(),
    addressLine4: new FormControl(),
    postalCode: new FormControl(),
    countryCode: new FormControl(),
    countryIso2: new FormControl(),
    countryIso3: new FormControl(),
    countryIsoNumber: new FormControl(),
    countryName: new FormControl(),
    type: new FormControl(),
    isOverrideAddress: new FormControl(),
  }),
  [PersonalDetailsFormField.EmailAddress]: new FormControl(null),
  [PersonalDetailsFormField.FirstName]: new FormControl(null),
  [PersonalDetailsFormField.LastName]: new FormControl(null),
  [PersonalDetailsFormField.PrivacyPolicy]: new FormControl(true, {
    nonNullable: true,
  }),
  [PersonalDetailsFormField.TelephoneNumber]: new FormControl(null),
};
